// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { PageMetadata, PageMetadataSchema } from 'api/gen/PageMetadata';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { UserProfileSubjectRoleManagementDtoAssociationRoleManagement, UserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema } from 'api/gen/UserProfileSubjectRoleManagementDtoAssociationRoleManagement';

const requiredPart = t.interface({
  content: t.union([t.array(UserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema), t.null]),
  page: t.union([PageMetadataSchema, t.null]),
});

export const PagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema = excess(requiredPart);

export interface PagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagement extends t.TypeOf<typeof PagedModelUserProfileSubjectRoleManagementDtoAssociationRoleManagementSchema> {}
